import { CHANNEL_CODE, CHANNEL_HEADER, setChannelCode } from './api/request'

export type TerminalConfig = {
  brandName: string
  assistantName: string
  slogan: string
  welcome?: string
  suggestions?: string[]
  channelCode: string
  logoUrl?: string
  iconUrl?: string
  primaryColor?: string
  features?: { voice?: boolean; share?: boolean; push?: boolean }
}

export const DEFAULT_TERMINAL_CONFIG: TerminalConfig = {
  brandName: '昭游智伴侣',
  assistantName: '小昭同学',
  slogan: '一问生成旅程，一屏智游昭通',
  channelCode: CHANNEL_CODE,
  primaryColor: '#5B9BD5',
  welcome: '您好！我是昭通避暑文旅智能顾问“昭游智伴侣”。无论是规划避暑行程、查询景点美食，还是了解交通、天气和便民服务，我都可以为您提供建议。\n\n一问生成旅程，一屏智游昭通。请问您想先了解什么？',
  suggestions: ['帮我规划昭通避暑行程', '昭通有哪些适合避暑的地方？', '推荐昭通特色美食和玩法'],
}

export async function loadTerminalConfig(): Promise<TerminalConfig> {
  const response = await fetch('/api/public/terminal/config', { headers: { [CHANNEL_HEADER]: CHANNEL_CODE } })
  if (!response.ok) throw new Error(`terminal config request failed: ${response.status}`)
  const config = { ...DEFAULT_TERMINAL_CONFIG, ...(await response.json()) }
  setChannelCode(config.channelCode)
  return config
}
